import { render, staticRenderFns } from "./LabelText.vue?vue&type=template&id=b686e396&scoped=true&"
import script from "./LabelText.vue?vue&type=script&lang=js&"
export * from "./LabelText.vue?vue&type=script&lang=js&"
import style0 from "./LabelText.vue?vue&type=style&index=0&id=b686e396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b686e396",
  null
  
)

export default component.exports